/// <reference path='../_all.ts' />


module partner {
  /**
   * Angular Service http://stackoverflow.com/questions/19447886/how-can-i-define-an-angularjs-service-using-a-typescript-class-that-doesnt-poll
   */
  export class PartnerService {
    static $inject = ['$http', '$q', 'CacheFactory'];

    constructor(
      // Add the parameter and type definition.
      public $http: ng.IHttpService,
      public $q: ng.IQService,
      public CacheFactory: CacheFactory.ICacheFactory
    ) {

        if (!CacheFactory.get('dataCache')) {
          CacheFactory.createCache('dataCache', {
            storageMode: 'sessionStorage', // This cache will use `sessionStorage`.
          });
        }
    
    } 

    public getPartnerData() : ng.IPromise<VendorResult> {
      var url : string = "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Vendor/"

      var deferred = this.$q.defer<VendorResult>();
      var start = new Date().getTime();
      var dataCache = this.CacheFactory.get('dataCache');

      //in cache?
      if (dataCache.get(url)) {
        deferred.resolve(dataCache.get(url));
        return deferred.promise;
      } 

      //embeded in html?
      var dataEl = document.getElementById('contact-data');
      if (dataEl) {
        var data : VendorResult = JSON.parse(dataEl.innerHTML);
        dataCache.put(url, data);
        deferred.resolve(data);
        return deferred.promise;
      }

      //fetch from network?
      this.$http<VendorResult>({
          method: "GET"
        , url: url
        , headers: { 'Content-Type': 'application/json' }
      }).then((response : { data : VendorResult}) :any => { //success
        dataCache.put(url, response.data);
        deferred.resolve(response.data);
      });   
      
      return deferred.promise;   

    }    
    
    
    public getPartnerLocation(v: Vendor) : ng.IPromise<google.maps.LatLngLiteral> {
      
      var deferred = this.$q.defer<google.maps.LatLngLiteral>();

      if (v.Location) {
        deferred.resolve(v.Location);
        return deferred.promise;
      }

      this.$http<google.maps.LatLngLiteral>({
          method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Vendor/Location"
        , params: {
          'vendorid' : v.ID
        }
        , headers: { 'Content-Type': 'application/json' }
      }).then((response : { data : google.maps.LatLngLiteral}) :any => { //success
        v.Location = response.data;
        deferred.resolve(response.data);
      });   
        
      return deferred.promise;   

    }

    //public getCountries() : ng.IPromise<Country[]> {
    //  return this.getPartnerData().then((data : VendorResult) =>  {
    //    if (this.countries.length > 0) this.$q.when(this.countries);
    //    data.Countries.forEach((c : Country, i : number, a : Country[]) => {
    //      this.countries.push(new Country(c.ID, c.Name,c.NormalizedName, null, null,null,null,c.Code));
    //    });
    //    return this.countries;
    //  });
    //}

    private rootElement : ng.IRootElementService;
    public getPartnerCtrlElement() : ng.IRootElementService {
      return this.rootElement;
    }

    public setPartnerCtrlElement(element : ng.IRootElementService) {
      this.rootElement = element;
    }
    
  }

}
